module.exports = __webpack_public_path__ + "assets/img/202109-4.021647bb.png";